var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",attrs:{"id":"spinner-overlay"}},[_c('div',{staticClass:"spinner-container"},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"variant":"primary"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }